module.exports = __webpack_public_path__ + "img/6297ec6.png";